import React, { createContext, useContext, useState } from 'react';
import IVideoState from '../models/State.interface';
import { IVideoDetail } from '../models/Video.interface';

const VideoContext: React.Context<IVideoState> = createContext({} as IVideoState);

export const useVideoContext: Function = () => useContext(VideoContext);

export const VideoProvider = (props: { children: JSX.Element }) => {
    const [player, setPlayer] = useState<videojs.VideoJsPlayer>({} as videojs.VideoJsPlayer);
    const [video, setVideo] = useState<IVideoDetail>({} as IVideoDetail);
    return (
        <VideoContext.Provider
            value={{
                player,
                setPlayer,
                video,
                setVideo,
            }}
        >
            {props.children}
        </VideoContext.Provider>
    );
};
